(function(){
  if (!location.pathname.includes('/collections/bebelissimo')) return;
  const dictionary={'Filter:':'Filtre:','Availability':'Disponibilitate','Price':'Preț','Sort by:':'Sortează după:','Most relevant':'Relevanță','Featured':'Recomandate','Best selling':'Cele mai vândute','Alphabetically, A-Z':'Alfabetic, A–Z','Alphabetically, Z-A':'Alfabetic, Z–A','Price, low to high':'Preț crescător','Price, high to low':'Preț descrescător','Date, old to new':'Cele mai vechi','Date, new to old':'Cele mai noi','products':'produse','product':'produs'};
  function translate(root){
    const walker=document.createTreeWalker(root,NodeFilter.SHOW_TEXT);let node;
    while(node=walker.nextNode()){
      if(!node.parentElement || /SCRIPT|STYLE|TEXTAREA/.test(node.parentElement.tagName)) continue;
      const raw=node.nodeValue,trimmed=raw.trim();
      if(dictionary[trimmed]) node.nodeValue=raw.replace(trimmed,dictionary[trimmed]);
      else if(/^\d+ products?$/.test(trimmed)) node.nodeValue=raw.replace(/products?/, 'produse');
    }
  }
  let pending=false;
  const run=()=>{pending=false;translate(document.body)};
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run);else run();
  const observer=new MutationObserver(()=>{if(!pending){pending=true;requestAnimationFrame(run)}});
  observer.observe(document.documentElement,{childList:true,subtree:true});
})();